import {Navbar} from "./Navbar";
import React, {useContext, useEffect, useState} from "react";
import {
    Box,
    Button, Checkbox,
    CircularProgress,
    Container,
    FormControl,
    FormLabel,
    Grid,
    Input,
    Sheet,
    Stack,
    Typography
} from "@mui/joy";
import {APIurl, stringPrice, stripeApiKey} from "../utils/Utils";
import {
    CardElement,
    CheckoutProvider,
    Elements,
    PaymentElement,
    useCheckout,
    useElements,
    useStripe
} from "@stripe/react-stripe-js";
import {Checkout} from "./AccountTestPayment";
import {PaymentIntent, StripeElementsOptions, StripePaymentElementOptions} from "@stripe/stripe-js";
import firebase from "firebase/compat/app";
import {AuthContext} from "../utils/AuthProvider";
import {Coupon, Invoices} from "../utils/Model";
import {Link} from "react-router-dom";
import {useTranslation} from "react-i18next";


export function PayWrapper() {

    const { i18n, t } = useTranslation();
    const {authState, userCompany, userData, subscriptions} = useContext(AuthContext)

    const [clientSecret, setClientSecret] = useState<string | null>(null);
    const [appliedCoupon, setAppliedCoupon] = useState<Coupon | null>(null);
    const [paymentIntent, setPaymentIntent] = useState<PaymentIntent | null>(null);
    const [loading, setLoading] = useState(false);

    const options: StripeElementsOptions = {
        clientSecret: clientSecret ?? "",
        appearance: {
            theme: 'stripe',
        },
    };

    useEffect(() => {
        createPaymentIntent().then(res => {
            setClientSecret(res.client_secret)
            setPaymentIntent(res.payment_intent)
        })
    }, [appliedCoupon]);

    if(clientSecret !== null && paymentIntent !== null && !loading) return (
        <Elements stripe={stripeApiKey} options={options}>
            <Pay />
        </Elements>
    )
    return (
        <Box sx={{width:'100%', minHeight:'100vh', display:'flex', flexDirection:'column', justifyContent:'center', alignItems: 'center'}}>
            <CircularProgress />
        </Box>
    )

    function Pay() {
        const stripe = useStripe();
        const elements = useElements();

        const [terms, setTerms] = useState(false);
        const [processingPayment, setProcessingPayment] = useState(false);

        const defaultPrice = "€ 14,99"

        const options2: StripePaymentElementOptions = {
            layout: {
                type: 'accordion',
                defaultCollapsed: false,
                radios: true,
                spacedAccordionItems: false
            }
        };

        if(subscriptions.length > 0) {
            return (
                <Box sx={{height: '100vh'}}>
                    <Navbar />
                    <Container sx={{py: {xs:"7rem", md:"10rem"}}}>
                        <Stack spacing={2}>
                            <Typography level="h2">{t("alreadyhavesub")}</Typography>
                            <Link to="/">
                                <Button>
                                    {t("backtoaccount")}
                                </Button>
                            </Link>
                        </Stack>
                    </Container>
                </Box>
            )
        } else return (
            <Box sx={{height: '100vh'}}>
                <Navbar />
                <Container sx={{py: {xs:"7rem", md:"10rem"}}}>
                    <Stack spacing={3}>
                        <Stack spacing={2}>
                            <Stack spacing={1}>
                                <Typography level="title-md" fontWeight="bold">{t("cart")}</Typography>
                                <Sheet variant="outlined" color="neutral" sx={{p:3, borderRadius:10}}>
                                    <Stack spacing={3} direction={{xs:"column", md:"row"}} justifyContent="space-between" alignItems={{xs:"start", md:"center"}}>
                                        <Stack direction="column">
                                            <Typography level="body-sm">{t("product")}</Typography>
                                            <Typography level="title-md" fontWeight="bold">{t("cinefx")}</Typography>
                                        </Stack>
                                        <Stack direction="column">
                                            <Typography level="body-sm">{t("type")}</Typography>
                                            <Typography level="title-md" fontWeight="bold">{t("subscription")}</Typography>
                                        </Stack>
                                        <Stack direction="column">
                                            <Typography level="body-sm">{t("frequency")}</Typography>
                                            <Typography level="title-md" fontWeight="bold">{t("annual")}</Typography>
                                        </Stack>
                                        <Stack direction="column">
                                            <Typography level="body-sm">{t("price")}</Typography>
                                            <Typography level="title-md" fontWeight="bold" sx={{textDecoration:"line-through"}}>{defaultPrice}</Typography>
                                        </Stack>
                                        <Stack direction="column">
                                            <Typography level="body-sm">{t("pricefirstyear")}</Typography>
                                            <Typography level="title-md" fontWeight="bold">{stringPrice(paymentIntent!.currency, paymentIntent!.amount)}</Typography>
                                        </Stack>
                                        <Stack direction="column">
                                            <Typography level="body-sm">{t("emailcinefxaccount")}</Typography>
                                            <Typography level="title-md" fontWeight="bold">{userData.email}</Typography>
                                        </Stack>
                                    </Stack>
                                </Sheet>
                                <Stack direction="column" justifyContent="center" alignItems="center" sx={{pt:3}}>
                                    <Typography level="body-sm">{t("topaytoday")}</Typography>
                                    <Typography level="h2" fontWeight="bold">{stringPrice(paymentIntent!.currency, paymentIntent!.amount)}</Typography>
                                    <Typography level="body-sm">{t("subrenewsat")} {defaultPrice}. {t("youcancancelanytime")} <a href="https://cinefx.danieledigregorio.it/terms" target="_blank" rel="noreferrer"><u>{t("termsandconditions")}</u></a>.</Typography>
                                </Stack>
                            </Stack>

                            <Stack spacing={1}>
                                <Typography level="title-md" fontWeight="bold">{t("paymentmethod")}</Typography>
                                <PaymentElement options={options2} />
                            </Stack>
                            <Checkbox label={<Typography>{t("declareto")} <a href="https://cinefx.danieledigregorio.it/terms" target="_blank" rel="noreferrer"><u>{t("termsandconditions")}</u></a> {t("andthe")}<a href="https://cinefx.danieledigregorio.it/privacy" target="_blank" rel="noreferrer"><u>{t("privacypolicy")}</u></a>.</Typography>}
                                      size="sm"
                                      checked={terms}
                                      onClick={() => setTerms(!terms)}
                            />
                            <Button
                                disabled={!terms || processingPayment}
                                onClick={() => {
                                    confirmPayment()
                                }}
                            >
                                {t("pay")}
                            </Button>
                        </Stack>
                    </Stack>
                </Container>
            </Box>
        )

        async function confirmPayment() {
            setProcessingPayment(true)
            try {
                elements?.submit()
                const result = await stripe?.confirmPayment({
                    elements: elements!,
                    clientSecret: clientSecret!,
                    confirmParams: {
                        return_url: `${window.location.origin}/completion`,
                    }
                })
                if(result?.error) {
                    //alert(result.error.message)
                }
            } catch (err) {
                console.error(err);
            } finally {
                setProcessingPayment(false)
            }
        }

    }

    async function createPaymentIntent() {
        setLoading(true)
        try {
            const user = firebase.auth().currentUser;
            if (!user) {
                return
            }
            const token = await user.getIdToken();

            const response = await fetch(`${APIurl}/createPaymentIntent`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`
                },
                body: JSON.stringify({
                    stripeCustomerId: userData.stripeCustomerId,
                    itemId: "price_1RQSovGzw2l8brmR8PtNBTvr",
                    uid: user.uid,
                })
            })
            if (!response.ok) {
                const error = await response.json();
                //alert(error);
                return;
            }

            return await response.json();
        } catch (e: unknown) {
            //alert(e)
        } finally {
            setLoading(false)
        }
    }
}
